export { FeedbackCollector } from './src/feedback-collector';
